export default __webpack_public_path__ + "static/media/ro_logo_mob.2d0d98df.svg";